// Recovered compiled webpack factory 13644. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  function r(e, t) {
    let r = {};
    return (
      Object.keys(e).forEach((n) => {
        t.includes(n) || (r[n] = e[n]);
      }),
      r
    );
  }
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "omit", {
      enumerable: !0,
      get: function () {
        return r;
      },
    }));
}
